<template>
    <div v-if="list">
        <h3 class="panel-title"><slot></slot></h3>
        <div class="tile mb-1" v-for="action in list">
            <div class="tile-icon">
                <figure class="avatar avatar-lg badge mr-2 bg-error" :data-badge="action.attack_bonus" data-initial="atk" style="font-size: 1em;">
                </figure>
                <figure class="avatar avatar-lg badge mr-2 bg-warning" :data-badge="action.damage_bonus" data-initial="dmg" style="font-size: 1em;"></figure>
            </div>
            <div class="tile-content">
                <h5 class="tile-title">{{action.name}}</h5>
                <p class="tile-subtitle text-dark">{{action.desc}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["list"]
}
</script>